import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CaseState {
  caseid: any;
  claimnumber: string;
  status: boolean;
  caseStage: any;
  caseInfoId: any;
  isSearchEditable: boolean;
  clientId: any;
  isUploadFile: boolean;
  isCancelFiles: boolean;
  isDashboard: boolean;
  newCaseInFoID: any;
  InterVal: any;
  actionType: any;
}

const initialState: CaseState = {
  caseid: "",
  claimnumber: "",
  status: false,
  caseStage: "",
  caseInfoId: null,
  isSearchEditable: false,
  clientId: "",
  isUploadFile: false,
  isCancelFiles: false,
  isDashboard: false,
  newCaseInFoID: null,
  InterVal: null,
  actionType: "",
};

const CaseDashoardSlice = createSlice({
  name: "case_header",
  initialState,
  reducers: {
    setCaseId: (state, action: PayloadAction<any>) => {
      state.caseid = action.payload;
    },
    setClaimNumber: (state, action: PayloadAction<string>) => {
      state.claimnumber = action.payload;
    },
    setStatus: (state, action: PayloadAction<boolean>) => {
      state.status = action.payload;
    },
    setCaseStage: (state, action: PayloadAction<any>) => {
      state.caseStage = action.payload;
    },
    setCaseInfoId: (state, action: PayloadAction<any>) => {
      state.caseInfoId = action.payload;
    },
    setIsSearchEditable: (state, action: PayloadAction<any>) => {
      state.isSearchEditable = action.payload;
    },
    setClientId: (state, action: PayloadAction<any>) => {
      state.clientId = action.payload;
    },
    setIsUploadFile: (state, action: PayloadAction<boolean>) => {
      state.isUploadFile = action.payload;
    },
    setIsCancelFiles: (state, action: PayloadAction<boolean>) => {
      state.isCancelFiles = action.payload;
    },
    setIsDashboard: (state, action: PayloadAction<boolean>) => {
      state.isDashboard = action.payload;
    },
    setNewCaseInFoID: (state, action: PayloadAction<any>) => {
      state.newCaseInFoID = action.payload;
    },
    setInterVal: (state, action: PayloadAction<any>) => {
      state.InterVal = action.payload;
    },
    setactionType: (state, action: PayloadAction<any>) => {
      state.actionType = action.payload;
    },
  },
});

export const {
  setCaseId,
  setClaimNumber,
  setStatus,
  setCaseStage,
  setCaseInfoId,
  setIsSearchEditable,
  setClientId,
  setIsUploadFile,
  setIsCancelFiles,
  setIsDashboard,
  setNewCaseInFoID,
  setInterVal,
  setactionType,
} = CaseDashoardSlice.actions;
export default CaseDashoardSlice.reducer;
